import { render, staticRenderFns } from "./smsTest.vue?vue&type=template&id=35983664&scoped=true"
import script from "./smsTest.vue?vue&type=script&lang=js"
export * from "./smsTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35983664",
  null
  
)

export default component.exports